import { enumSchemaFromDynamicArray } from '@common/neo.tax';
import { z } from 'zod';

import { FilterSortDataType } from '@neo.tax/shared/utils';

import { OperatorName } from './operators';

// Filters and sorting share the same ColumnDefinition
export type { ColumnDefinition } from '../../sort-popover';

export const makeConditionRowSchema = <ColumnNames extends string[]>(
  columnNames: ColumnNames,
): z.ZodType<ConditionRow<ColumnNames[number]>> =>
  z.object({
    id: z.string().describe('For draggable and making direction nullable.'),
    column: enumSchemaFromDynamicArray(columnNames),
    dataType: z.enum(FilterSortDataType),
    operator: z.enum(OperatorName),
    value: z.union([z.string(), z.number(), z.null()]),
  });

export const makeConditionsSchema = <ColumnName extends string>(
  columnNames: ColumnName[],
): z.ZodType<Conditions<ColumnName>> => {
  const conditionRowSchema = makeConditionRowSchema(columnNames);
  return z.object({
    booleanOperator: z.enum(['AND', 'OR']),
    conditionRows: z.array(conditionRowSchema),
  });
};

export interface ConditionRow<ColumnName extends string> {
  id: string;
  column: ColumnName;
  dataType: FilterSortDataType;
  operator: OperatorName;
  value: string | number | null;
}

export interface Conditions<ColumnName extends string> {
  booleanOperator: 'AND' | 'OR';
  conditionRows: ConditionRow<ColumnName>[];
}
